/**
 * 색상 프리셋 팔레트 — Button, SubscribeForm 등에서 공유
 * @app/views/spaces/owner/settings/home.html.erb 의 프리셋과 동일
 */
export const COLOR_PRESETS = [
  { text: "#FFFFFF", bg: "#1A6140" },
  { text: "#000000", bg: "#FFFFFF" },
  { text: "#1F1F1F", bg: "#F0F0F0" },
  { text: "#333333", bg: "#FFFAF0" },
  { text: "#073642", bg: "#FDF6E3" },
  { text: "#8B0000", bg: "#FFF5EE" },
  { text: "#006400", bg: "#F0FFF0" },
  { text: "#800080", bg: "#FFF0F5" },
  { text: "#2F4F4F", bg: "#F5FFFA" },
  { text: "#222222", bg: "#FAFAD2" },
  { text: "#3A3A3A", bg: "#FFF8DC" },
  { text: "#2C3E50", bg: "#ECF0F1" },
  { text: "#2E2E2E", bg: "#FFFAFA" },
  { text: "#3E2723", bg: "#FFEBEE" },
  { text: "#1B5E20", bg: "#E8F5E9" },
  { text: "#0D47A1", bg: "#E3F2FD" },
  { text: "#BF360C", bg: "#FFF3E0" },
];

/**
 * 프리셋 팔레트 HTML을 생성 (인라인 — 넓은 영역용)
 * @param {Function} onSelect - (textColor, bgColor) => void
 * @param {{ text: string, bg: string }|null} primaryColors - writer 기본 색상 (1번 프리셋을 대체)
 * @returns {HTMLElement}
 */
export function createColorPresetPalette(onSelect, primaryColors = null) {
  const container = document.createElement("div");
  container.style.cssText = "display: flex; flex-wrap: wrap; gap: 4px;";
  _appendSwatches(container, onSelect, primaryColors);
  return container;
}

/**
 * 프리셋 팔레트 드롭다운 (좁은 영역용 — 버튼 클릭 시 토글)
 * @param {Function} onSelect - (textColor, bgColor) => void
 * @param {{ text: string, bg: string }|null} primaryColors - writer 기본 색상 (1번 프리셋을 대체)
 * @returns {HTMLElement}
 */
export function createColorPresetDropdown(onSelect, primaryColors = null) {
  const wrapper = document.createElement("div");
  wrapper.style.cssText = "position: relative; display: flex; align-items: center; flex-shrink: 0;";

  const toggle = document.createElement("button");
  toggle.type = "button";
  toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21a9 9 0 0 1 0 -18c4.97 0 9 3.582 9 8c0 1.06 -.474 2.078 -1.318 2.828c-.844 .75 -1.989 1.172 -3.182 1.172h-2.5a2 2 0 0 0 -1 3.75a1.3 1.3 0 0 1 -1 2.25" /><circle cx="8.5" cy="10.5" r="1" fill="currentColor" /><circle cx="12.5" cy="7.5" r="1" fill="currentColor" /><circle cx="16.5" cy="10.5" r="1" fill="currentColor" /></svg>';
  toggle.style.cssText = "width: 34px; height: 34px; border: none; background: none; cursor: pointer; color: #1e293b; transition: color 0.15s; flex-shrink: 0; display: flex; align-items: center; justify-content: center; padding: 0;";

  const dropdown = document.createElement("div");
  dropdown.style.cssText = "display: none; position: absolute; bottom: calc(100% + 4px); left: 0; background: white; border: 1px solid #e2e8f0; border-radius: 6px; padding: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); z-index: 100; min-width: 200px;";

  const isDark = document.documentElement.classList.contains('dark');
  if (isDark) {
    toggle.style.color = "#a3a3a3";
    dropdown.style.background = "#1c1917";
    dropdown.style.borderColor = "#374151";
  }

  const grid = document.createElement("div");
  grid.style.cssText = "display: flex; flex-wrap: wrap; gap: 4px;";
  _appendSwatches(grid, (textColor, bgColor) => {
    onSelect(textColor, bgColor);
    dropdown.style.display = "none";
  }, primaryColors);
  dropdown.appendChild(grid);

  const hoverColor = isDark ? "#d1d5db" : "#000000";
  const defaultColor = isDark ? "#a3a3a3" : "#1e293b";
  toggle.addEventListener("mouseenter", () => { toggle.style.color = hoverColor; });
  toggle.addEventListener("mouseleave", () => { toggle.style.color = defaultColor; });
  toggle.addEventListener("click", (e) => {
    e.stopPropagation();
    dropdown.style.display = dropdown.style.display === "none" ? "block" : "none";
  });

  // 외부 클릭 시 닫기
  document.addEventListener("click", (e) => {
    if (!wrapper.contains(e.target)) dropdown.style.display = "none";
  });

  wrapper.appendChild(toggle);
  wrapper.appendChild(dropdown);
  return wrapper;
}

function _appendSwatches(container, onSelect, primaryColors = null) {
  const presets = primaryColors
    ? [primaryColors, ...COLOR_PRESETS.slice(1)]
    : COLOR_PRESETS;
  presets.forEach(({ text, bg }) => {
    const swatch = document.createElement("button");
    swatch.type = "button";
    swatch.textContent = "가";
    swatch.style.cssText = `
      width: 26px; height: 26px; border-radius: 4px; border: 1px solid #e2e8f0;
      font-size: 11px; font-weight: 500; cursor: pointer; transition: transform 0.1s;
      background: ${bg}; color: ${text}; line-height: 1; padding: 0;
    `;
    swatch.addEventListener("mouseenter", () => { swatch.style.transform = "scale(1.15)"; });
    swatch.addEventListener("mouseleave", () => { swatch.style.transform = "scale(1)"; });
    swatch.addEventListener("click", (e) => {
      e.stopPropagation();
      onSelect(text, bg);
    });
    container.appendChild(swatch);
  });
}
